import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {ConfigPage} from "../page/overview/config/config.page";
import {
    BlogPostPreviewComponent
} from "../component/protected-components/create-blog-post-component/blog-post-preview-component/blog-post-preview.component";
import {
    CreateBlogPostComponent
} from "../component/protected-components/create-blog-post-component/create-blog-post.component";
import {
    OlOutletObjectComponent
} from "../component/object-components/ol-outlet-object-component/ol-outlet-object.component";
import {
    OlOutletSideComponent
} from "../component/object-components/ol-outlet-object-component/view/ol-outlet-side-component/ol-outlet-side-component";
import {
    OlOutletFullComponent
} from "../component/object-components/ol-outlet-object-component/view/ol-outlet-full-component/ol-outlet-full-component";
import {
    OlOutletComponent
} from "../component/object-components/ol-outlet-object-component/shared/components/ol-outlet-component/ol-outlet.component";
import {
    OlOutletBlogPostComponent
} from "../component/object-components/ol-outlet-object-component/shared/components/ol-outlet-blog-post-component/ol-outlet-blog-post.component";
import {
    OlOutletBlogGhostWriterComponent
} from "../component/object-components/ol-outlet-object-component/shared/components/ol-outlet-blog-ghost-writer-component/ol-outlet-blog-ghost-writer.component";
import {
    OlOutletActiveThemeComponent
} from "../component/object-components/ol-outlet-object-component/shared/components/ol-outlet-active-theme-component/ol-outlet-active-theme.component";
import {
    OutletInfoComponent
} from "../page/ol-outlet-dashboard-overview/components/outlet-info-component/outlet-info.component";
import {
    OlOutletDashboardOverviewComponent
} from "../page/ol-outlet-dashboard-overview/ol-outlet-dashboard-overview.component";


const olModuleEntry: TestModuleDefinition = {
    key: 'ol',
    label: 'Outlet (ol)',
    components: [
        {
            key: 'BlogPostPreviewComponent',
            component: BlogPostPreviewComponent,
            selector: 'ol-blog-post-preview',
            type: 'Component',
            label: 'blog post preview component'
        },
        {
            key: 'CreateBlogPostComponent',
            component: CreateBlogPostComponent,
            selector: 'ol-create-blog-post',
            type: 'Component',
            label: 'create blog post component'
        },
        {
            key: 'OlOutletObjectComponent',
            component: OlOutletObjectComponent,
            selector: 'ol-outlet-object',
            type: 'ObjectBaseComponent',
            label: 'ol outlet object component'
        },
        {
            key: 'OlOutletSideComponent',
            component: OlOutletSideComponent,
            selector: 'ol-outlet-side',
            type: 'OlOutletBaseComponent',
            label: 'ol outlet side component'
        },
        {
            key: 'OlOutletFullComponent',
            component: OlOutletFullComponent,
            selector: 'ol-outlet-full',
            type: 'OlOutletBaseComponent',
            label: 'ol outlet full component'
        },
        {
            key: 'OlOutletComponent',
            component: OlOutletComponent,
            selector: 'ol-outlet',
            type: 'Component',
            label: 'ol outlet component'
        },
        {
            key: 'OlOutletBlogPostComponent',
            component: OlOutletBlogPostComponent,
            selector: 'ol-outlet-blog-post',
            type: 'Component',
            label: 'ol outlet blog post component'
        },
        {
            key: 'OlOutletBlogGhostWriterComponent',
            component: OlOutletBlogGhostWriterComponent,
            selector: 'ol-outlet-blog-ghost-writer',
            type: 'Component',
            label: 'ol outlet blog ghost writer component'
        },
        {
            key: 'OlOutletActiveThemeComponent',
            component: OlOutletActiveThemeComponent,
            selector: 'ol-outlet-active-theme',
            type: 'Component',
            label: 'ol outlet active theme component'
        },
        {
            key: 'OutletInfoComponent',
            component: OutletInfoComponent,
            selector: 'ol-outlet-info',
            type: 'Component',
            label: 'outlet info component'
        },
        {
            key: 'OlOutletDashboardOverviewComponent',
            component: OlOutletDashboardOverviewComponent,
            selector: 'ol-outlet-dashboard-overview',
            type: 'PageComponent',
            label: 'ol outlet dashboard overview component'
        },
        {
            key: 'ConfigPage',
            component: ConfigPage,
            selector: 'ol-config',
            type: 'PageComponent',
            label: 'config page'
        }
    ]
}

export const OL_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: olModuleEntry, multi: true}
];